import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { NgInject } from '@df/ng/ng-inject';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { Subscription } from 'rxjs';
import { NProductListingFiltersModal } from '../../../../../listing/filter/filter-modal.component';
@Component({
    selector: 'builder-listing-tools',
    templateUrl: './builder-listing-tools.html',
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuilderListingToolsComponent extends UiComponent implements OnChanges, OnDestroy {
    @Input()
    title: string | number;
    @Input()
    listing: ProductListing;
    private listingSubscription: Subscription;
    @NgInject(DfModalService)
    readonly dfModalService: DfModalService;

    showFiltersModal(): void {
        this.dfModalService.open(undefined, NProductListingFiltersModal.id, undefined, this.listing);
    }

    override ngOnChanges() {
        this.listingSubscription?.unsubscribe();
        this.listingSubscription = this.listing.subscribe(() => this.detectChanges());
        this.detectChanges();
    }

    override ngOnDestroy(): void {
        this.listingSubscription.unsubscribe();
        super.ngOnDestroy();
    }

    protected getFiltersForChips(): FilterAttributeOption<any>[] {
        return this.listing.getFiltersWithSelection().filter(i => i.filterType === 'attribute-option') as FilterAttributeOption<any>[];
    }

    get noResults(): boolean {
        return this.listing.getTotal() === 0;
    }
}
